import Vue from 'vue'
import Router from 'vue-router'
import Login from "@/pages/login"
import Share from "@/pages/share"

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'login',
			component: Login
		},
    {
    	path: '/share',
    	name: 'share',
    	component: Share
    },
		{
			path: '/mainCom',
			name: 'mainCom',
			component: resolve => require(['@/components/mainCom'],resolve),
			children: [
				{
					path: '/user',
					name: 'user',
					component:()=>import('@/pages/configuration/user')
				},
				{
					path: '/orders',
					name: 'orders',
					component: () => import('@/pages/maintenance/orders')
				},
				{
					path: '/recode',
					name: 'recode',
					component: () => import('@/pages/maintenance/recode')
				},
				{
					path: '/maintenance',
					name: 'maintenance',
					component: () => import('@/pages/maintenance/maintenance')
				},
				{
					path: '/mRecode',
					name: 'mRecode',
					component: () => import('@/pages/maintenance/mRecode')
				},
				{
					path: '/role',
					name: 'role',
					component: () => import('@/pages/configuration/role')
				},
				{
					path: '/maintenancePlan',
					name: 'maintenancePlan',
					component: () => import('@/pages/configuration/maintenancePlan')
				},
				{
					path: '/owner',
					name: 'owner',
					component: () => import('@/pages/configuration/owner')
				},
				{
					path: '/department',
					name: 'department',
					component: () => import('@/pages/configuration/department')
				},
				{
					path: '/equipment',
					name: 'equipment',
					component: () => import('@/pages/configuration/equipment')
				},
				{
					path: '/maintenanceDw',
					name: 'maintenanceDw',
					component: () => import('@/pages/configuration/maintenanceDw')
				},
				{
					path: '/maintenanceProject',
					name: 'maintenanceProject',
					component: () => import('@/pages/configuration/maintenanceProject')
				},
				{
					path: '/statisticsEq',
					name: 'statisticsEq',
					component: () => import('@/pages/maintenance/statisticsEq')
				},
				{
					path: '/statisticsPeople',
					name: 'statisticsPeople',
					component: () => import('@/pages/maintenance/statisticsPeople')
				},
				{
					path: '/repairDetail',
					name: 'repairDetail',
					component: () => import('@/pages/maintenance/repairDetail')
				},
				{
					path: '/maintainDetail',
					name: 'maintainDetail',
					component: () => import('@/pages/maintenance/maintainDetail')
				},
				{
					path: '/parts',
					name: 'parts',
					component: () => import('@/pages/configuration/parts') 
				}
			]
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js